/* eslint-disable react/jsx-indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
// import moment from 'moment';
// import { Form } from 'react-formio';
import moment from 'moment';
import {
  AddPartsDisplay,
  ContentText,
  DetailsContainer,
  LabelToolTip,
  PartRequestContainer
  // DetailSection, NormalText
} from './WorkOrderDetails.style';
// import { STATUSES } from '../../../constants';
import './RenderDetails.css';
// import { getWorkOrderDetails } from './getDetails';
import { Table } from '../..';
import DynamicSVGIcon from '../../Common/DynamicSVGIcon';
import { help } from '../../../assets/icons';
import { format as dateFormat } from '../../../config/index';
import { isEmpty } from '../../../shared/utility/isEmpty';
import { getStringLocale } from '../../../constants/language';

const LabelItem = ({
  label,
  value,
  tooltip
  //  nonEditable
}) => (
  <DetailsContainer className='detail ai' width='100%'>
    <ContentText
      style={{ minWidth: window.innerWidth >= 768 ? '40rem' : '13rem' }}
      className='heading'
    >
      {getStringLocale(label)}
      {tooltip && (
        <div style={{ marginLeft: '2px' }}>
          <DynamicSVGIcon iconUrl={help} />
          <LabelToolTip className='top'>
            <ContentText>{tooltip}</ContentText>
          </LabelToolTip>
        </div>
      )}
    </ContentText>
    <span>:</span>
    <ContentText className='label ml'>{value || '-'}</ContentText>
  </DetailsContainer>
);

const RenderDetails = ({ detailType = '' }) => {
  const { workOrderDetails } = useSelector((state) => state.workOrders);
  // console.log('workOrderDetails===>', workOrderDetails);

  const partsRequest = workOrderDetails?.filter(
    (WO) => WO?.label === 'Parts Requested'
  );

  if (detailType) {
    if (isEmpty(partsRequest)) {
      return <AddPartsDisplay>{getStringLocale('Add Parts')}</AddPartsDisplay>;
    }
    const { value } = partsRequest[0];
    const { labels, values } = value || {};
    return values?.map((value, index1) => (
      <PartRequestContainer key={index1}>
        {labels?.map((label, index2) => (
          <div key={`${Math.random()}-${index2}`}>
            <LabelItem
              label={label?.label}
              // value={format ? moment(value).format(format) : value || defaultValue}
              value={value[label?.value]}
            />
          </div>
        ))}
      </PartRequestContainer>
    ));
  }

  return (
    <>
      {workOrderDetails && (
        <DetailsContainer width='100%'>
          {isEmpty(detailType) &&
            workOrderDetails?.map((detail, i) => {
              const { label, value, defaultValue, format, tooltip } = detail;
              if (
                (value && typeof value !== 'object') ||
                (defaultValue && typeof defaultValue !== 'object')
              ) {
                // console.log('lable-1', label, 'value-1', value, defaultValue);
                return (
                  <React.Fragment key={i}>
                    <LabelItem
                      label={label}
                      tooltip={tooltip}
                      // value={format ? moment(value).format(format) : value || defaultValue}
                      value={
                        format
                          ? value
                            ? moment(value).format(dateFormat)
                            : '-'
                          : value || defaultValue
                      }
                    />
                  </React.Fragment>
                );
              }
            })}
          {workOrderDetails?.map((detail, i) => {
            const { label, value, defaultValue } = detail;

            // if (typeof value === 'object' && value.values?.length) {
            if (
              (value && typeof value === 'object' && value.values?.length) ||
              (defaultValue &&
                typeof defaultValue === 'object' &&
                defaultValue.values?.length)
            ) {
              // console.log('label-2', label, 'value-2', value, defaultValue);
              return (
                <div style={{ width: '100%', overflow: 'auto' }} key={i}>
                  <ContentText
                    className='table heading Language'
                    data-label={label}
                  >
                    {getStringLocale(label)}
                  </ContentText>
                  <Table
                    colProps={value.labels}
                    data={value.values}
                    defaultValue={value?.defaultValues[0]}
                  />
                </div>
              );
            }
          })}
        </DetailsContainer>
      )}
    </>
  );
};

export default RenderDetails;
